import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shatter-container" }
const _hoisted_2 = {
  ref: "canvasRef",
  class: "shatter-canvas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "shatter-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
    }, _toDisplayString(_ctx.buttonText), 1),
    _withDirectives(_createElementVNode("canvas", _hoisted_2, null, 512), [
      [_vShow, _ctx.isShattered]
    ])
  ]))
}